import { render, staticRenderFns } from "./form2.vue?vue&type=template&id=67129b8e&"
import script from "./form2.vue?vue&type=script&lang=js&"
export * from "./form2.vue?vue&type=script&lang=js&"
import style0 from "./form2.vue?vue&type=style&index=0&id=67129b8e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports